import { render, staticRenderFns } from "./UnidadeBalancoTiposVeiculo.vue?vue&type=template&id=167943d7&scoped=true&"
import script from "./UnidadeBalancoTiposVeiculo.vue?vue&type=script&lang=js&"
export * from "./UnidadeBalancoTiposVeiculo.vue?vue&type=script&lang=js&"
import style0 from "./UnidadeBalancoTiposVeiculo.vue?vue&type=style&index=0&id=167943d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167943d7",
  null
  
)

export default component.exports